module.exports = __webpack_public_path__ + "media/images/calendar-clock-3b3a4a3c678e0a73ba625f3009a822ca.png";